// extracted by mini-css-extract-plugin
export default {"infoValue":"WorkpackMapInfo_infoValue__GE-T-"};